import { QuotesState } from "../state/quotesState";
import {
    IS_LOADING,
    CLEAR_FILTERS,
    CLEAR_QUOTE_DETAIL_DATA,
    RECEIVE_QUOTE_ITEM_ROW_DECO_DETAILS,
    UPDATE_FILTERS,
    RECEIVE_QUOTE_ITEM,
    RECEIVE_QUOTE_ITEMS,
    RECEIVE_QUOTE_ITEM_DETAILS,
    RECEIVE_QUOTE_ITEM_ROWS,
    RECEIVE_QUOTE_ITEM_ROW_DETAILS,
    RECEIVE_PRODUCT,
    SET_SAVE_BTN,
    SET_ITEMS_SELECTED,
    RECEIVE_QUOTE_ITEM_ROWS_CHARGES,
    RECEIVE_QUOTE_DECORATION_LOCATIONS,
    RECEIVE_QUOTE_DECORATION_TYPE,
    IS_LOADER,
    RECEIVE_QARTWORKS_LIST,
    RECEIVE_QUOTE_DECORATORS_VENDORS_LIST,
    RECEIVE_QUOTE_DECORATORS_TYPE_LIST, RECEIVE_QUOTE_CONTENT,
} from '../actions/quotesActions'
import { RECEIVE_CURRENT_USER } from "../actions/sessionActions";
import { User } from "../../models/User";
import { RECEIVE_QUOTE } from "../actions/quotesActions";

export const initState: QuotesState = {
    fetchError: false,
    quotes: {},
    filters: {
        orderStatus: [],
        account_id: "",
        contact_id: "",
        cp_user_id: "",
        orderIdentity:"",
        orderNo:"",
        mainSearch:""
    },
    statuses: [],
    loading: false,
    saveBtn: false,
    cleared: 0,
    changeOnItems: [],
    selectedItems: [],
    quoteItemCharges:[],
    quoteItemDetail: {},
    decoratorsTypeList:[],
    meta:null,
    page: 0,
    count: 1,
}

const QuoteReducer = (state: QuotesState = initState, action) => {
    switch (action.type) {
        case RECEIVE_CURRENT_USER: {
            const currentUser: User = action.currentUser;
            if (currentUser.portalPermissions && currentUser.portalPermissions.Quote[0].allowedOtherContacts){
                return {
                  ...state,
                  statuses: currentUser.portalPermissions && currentUser.portalPermissions.Quote[0].allowedStatus,
                  filters: {
                    ...state.filters,
                    account_id: action.currentUser.accountId,
                    contact_id: !action.currentUser.portalPermissions.Quote[0].allowedOtherContacts?action.currentUser.contactId:'',
                    orderStatus: currentUser.portalPermissions && currentUser.portalPermissions.Quote[0].allowedStatus,
                  },
                };
            } else {
                return {
                  ...state,
                  statuses: currentUser.portalPermissions.Quote[0].allowedStatus,
                  filters: {
                    ...state.filters,
                    account_id: action.currentUser.accountId,
                    orderStatus: currentUser.portalPermissions.Quote[0].allowedStatus,
                    contact_id: !action.currentUser.portalPermissions.Quote[0].allowedOtherContacts?action.currentUser.contactId:'',
                  },
                };
            }
            
        }
        case RECEIVE_QUOTE_DECORATION_LOCATIONS: {
            return {
                ...state,
                loading: false,
                decorationLocations: action.payload.data, 
            }
        }
        case RECEIVE_QUOTE_DECORATORS_TYPE_LIST: {
            return {
                ...state,
                loading: false,
                decoratorsTypeList: action.payload,                
            }
        }
        case CLEAR_QUOTE_DETAIL_DATA: {
            return {
                ...state,
                quoteItemDetails: null,
                quoteItemRows: null,
                quoteItemRowDetails: null,
                quoteProductDetails: null,
                selectedItems: [],
                quoteItem: null,
                quoteItemsList: null
            }
        }
        case RECEIVE_QUOTE: {
            return {
                ...state,
                quotes: action.payload,
                loading: false,
                fetchError: false,
                count: action.count,
                meta:action.meta
            }
        }
        case RECEIVE_QUOTE_ITEM: {
            return {
                ...state,
                quoteItem: action.payload,
                loading: false,
                loaderOnly: false,
                fetchError: false,
            }
        }
        case RECEIVE_QUOTE_CONTENT: {
            return {
                ...state,
                quoteItemDetail: action.payload,
                loading: false,
                loaderOnly: false,
                fetchError: false,
            }
        }
        case RECEIVE_QUOTE_ITEMS: {
            return {
                ...state,
                quoteItemsList: action.payload,
                loading: false,                
                fetchError: false,
                selectedItems: []
            }
        }
        case RECEIVE_QUOTE_DECORATION_TYPE: {
            return {
                ...state,
                loading: false,
                decorationTypes: action.payload.data, 
            }
        }
        case RECEIVE_QUOTE_DECORATORS_VENDORS_LIST: {
            return {
                ...state,
                loading: false,
                decoratorsVendorsList: action.payload,                
            }
        }
        case RECEIVE_QUOTE_ITEM_DETAILS: {
            return {
                ...state,
                quoteItemDetails: action.payload,
                loading: false,                
                fetchError: false,
            }
        }
        case RECEIVE_QUOTE_ITEM_ROWS_CHARGES: {
            return {
                ...state,
                quoteItemCharges: action.payload,
                loading: false,                
                fetchError: false,
            }
        }
        case RECEIVE_QUOTE_ITEM_ROW_DECO_DETAILS: {
            return {
                ...state,
                quoteItemRowDecoDetails: action.payload,
                loading: false,                
                fetchError: false,
            }
        }
        case RECEIVE_PRODUCT: {
            return {
                ...state,
                quoteProductDetails: action.payload,
                loading: false,                
                fetchError: false,
            }
        }
        case SET_SAVE_BTN: {
            return {
                ...state,
                saveBtn: action.payload,
                changeOnItems: action.changeOnItems
            }
        }
        case RECEIVE_QUOTE_ITEM_ROW_DETAILS: {
            return {
                ...state,
                quoteItemRowDetails: action.payload,
                loading: false,                 
                fetchError: false,
            }
        }
        case RECEIVE_QUOTE_ITEM_ROWS: {
            return {
                ...state,
                quoteItemRows: action.payload,
                loading: false,                
                fetchError: false,
            }
        }
        case UPDATE_FILTERS: {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload
                }
            }
        }
        case CLEAR_FILTERS: {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    orderStatus: [...action.payload],
                    orderNo: "",
                    orderIdentity: "",
                    mainSearch:""
                },
                cleared: state.cleared + 1
            };
        }
        case RECEIVE_QARTWORKS_LIST: {
            return {
                ...state,
                loading: false,
                artworkList: action.payload,                
            }
        }
        case IS_LOADING: return {
            ...state,
            loading: action.loading
        }
        case IS_LOADER: return {
            ...state,
            loaderOnly: action.loaderOnly
        }
        case SET_ITEMS_SELECTED: return {
            ...state,
            selectedItems: action.items
        }
        default:
            return state;
    }
}

export default QuoteReducer;
